import { PageListTemplate } from '@templates';
import { ColumnType } from 'antd/es/table';

import type { PageListColumnVisibilityConfig } from 'src/app/framework/templates/PageList/PageList.interface';
import type { PageListColumnOrderState } from 'src/app/framework/templates/PageList/usePageListColumnOrder';
import type { PageListColumnVisibilityState } from 'src/app/framework/templates/PageList/usePageListColumnVisibility';
import { CountResponse } from 'src/app/typings/CountResponse';

import { useOfferUpsellFlowOptions } from '../../hooks/useOfferUpsellFlowOptions';
import {
  OfferListItem,
  OfferProperties,
} from '../../interfaces/offersInterface';
import { OfferFilters } from './OfferFilters';

interface TableOfferProps {
  data?: CountResponse<OfferListItem>;
  initialFilters?: Record<string, any>;
  onChangeFilter: (filters: Record<string, any>) => void;
  onChangePagination: (take: number, _: any, pagination: number) => void;
  pageSize: number;
  currentPage: number;
  headerColumns: ColumnType<OfferListItem>[];
  columnOrderState?: PageListColumnOrderState<OfferListItem>;
  columnVisibilityState?: PageListColumnVisibilityState<OfferListItem>;
  offerProperties?: OfferProperties;
  upsellFlowOptions: ReturnType<typeof useOfferUpsellFlowOptions>;
}

export type TColumnOfferOrder = {
  column: string;
  inverse: boolean;
};

export const OFFER_COLUMN_VISIBILITY_CONFIG: PageListColumnVisibilityConfig = {
  enabled: true,
  persist: true,
  storageKey: 'offers-list-column-visibility',
  alwaysVisibleColumnKeys: ['action'],
};
export const OFFER_DRAG_COLUMN_STORAGE_KEY = 'offers-list-drag-column';
export const OFFER_FIXED_COLUMN_KEYS = ['action'];

export const TableOffer = ({
  data,
  initialFilters,
  onChangePagination,
  pageSize,
  currentPage,
  onChangeFilter,
  headerColumns,
  columnOrderState,
  columnVisibilityState,
  offerProperties,
  upsellFlowOptions,
}: TableOfferProps) => {
  return (
    <PageListTemplate
      columns={headerColumns}
      filterComponent={
        <OfferFilters
          offerProperties={offerProperties}
          upsellFlowOptions={upsellFlowOptions}
          initialFilters={initialFilters}
          onFilter={onChangeFilter}
        />
      }
      data={data}
      pageSize={pageSize}
      currentPage={currentPage}
      onChange={onChangePagination}
      columnVisibilityConfig={OFFER_COLUMN_VISIBILITY_CONFIG}
      columnOrderState={columnOrderState}
      columnVisibilityState={columnVisibilityState}
      enableDragColumn
      dragColumnStorageKey={OFFER_DRAG_COLUMN_STORAGE_KEY}
      stickyHeader
      onChangePagination={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
    />
  );
};
